module.exports = {"232761001":"东山街道","232761002":"卫东街道","232761003":"红旗街道","232761004":"长虹街道","232761005":"曙光街道","232761006":"光明街道","232761200":"加北乡","232761201":"白桦乡"}


//////////////////
// WEBPACK FOOTER
// ./src/town/232761.json
// module id = 903
// module chunks = 0